const ActionNamesTaken = new Set();
const ActionNames = new WeakMap();
let AnonymousNameCounter = 0;

// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function getActionName(action: Function) {
  let actionName = ActionNames.get(action);
  if (actionName) {
    return actionName;
  }

  // Named actions will reserve their name. Duplicates will get auto-assigned a derivative name.
  if (action.name && !ActionNamesTaken.has(action.name)) {
    ActionNames.set(action, action.name);
    ActionNamesTaken.add(action.name);
    return action.name;
  }

  AnonymousNameCounter += 1;
  actionName = `${action.name || 'anonymous'}__#${AnonymousNameCounter}`;
  ActionNames.set(action, actionName);
  return actionName;
}
